window.dynamicSort = true;

// For rapid requests, ensure we process using the latest
let latestRequestId = 0;
async function updatePage (destinationUrl, pageCleanups) {

	try {

		latestRequestId++; // Side-effect: since function is async it may change during await fetch
		const requestId = latestRequestId;
		const response = await fetch(destinationUrl, {
			headers: {
				'X-Dynamic-Navigation': "True"
			}
		});

		// For rapid requests, ensure we process using the latest
		if (requestId !== latestRequestId) {

			return undefined;

		}

		if (!response.ok) {

			throw new Error('Request failed');

		}

		const htmlString = await response.text();
		const parser = new DOMParser();
		const doc = parser.parseFromString(htmlString, "text/html");

		// If site version is not the same, navigate to the full page
		const currentSiteVersion = document.documentElement.getAttribute('data-siteversion');
		const nextpageSiteVersion = doc.documentElement.getAttribute('data-siteversion');
		if (currentSiteVersion != nextpageSiteVersion) {

			throw new Error('New site version, navigate to the full page');

		}

		function updateHeadElement(selector) {

			const currentElement = document.head.querySelector(selector);
			const nextElement = doc.head.querySelector(selector);
			if (currentElement) {

				currentElement.remove();

			}
			
			if (nextElement) {

				document.head.append(nextElement);

			}

		}

		// Update head
		updateHeadElement('title');
		updateHeadElement('meta[name="description"]');
		updateHeadElement('meta[property="og:title"]');
		updateHeadElement('link[rel="canonical"]');
		updateHeadElement('meta[name="robots"]');
		updateHeadElement('meta[property="og:image"]');
		updateHeadElement('meta[property="og:description"]');
		updateHeadElement('meta[property="og:url"]');

		// Update body
		const el = doc.querySelector('#lpContainer');

		pageCleanups.forEach((cleanup) => {
			cleanup();
		});
		pageCleanups = [];
		
		const original = document.querySelector('#lpContainer');
		original.replaceWith(el);

		// Update utag_data		
		const utagDataScript = doc.querySelector('script#script_utag_data');
		if (utagDataScript) {

			window.isTagUniversalDataObjectIncluded = false;
			window.utag_data = {};
			eval(utagDataScript.innerText);

		}		

		// Update pageData
		const pageDataScript = doc.querySelector('script#script_pageData');
		if (pageDataScript) {

			window.lp.pageData = {};
			eval(pageDataScript.innerText);

		}

		// Update resx
		const resxScript = doc.querySelector('script#script_resx');
		if (resxScript) {

			eval(resxScript.innerText);

		}

		if (window.utag) {

			window.utag_data.page_name = document.title;

			// Call page view with the updated utag_data
			window.setTimeout(() => {

				window.utag.view(window.utag_data);

			}, 0);

			// Bluecore
			if (window.triggermail) {

				window.triggermail.config.ignoreTrackLibEventCache = true;
				window.triggermail.integ.partnerInit();
				window.triggermail.config.ignoreTrackLibEventCache = false;

			}

			// Bing
			if (window.uetq) {

				window.uetq.push('event', 'page_view', { page_path: window.location.pathname });

			}

		}

		// Scroll up to h1 if needed
		const sortContainer = document.getElementById('sortContainer');
		// h1 is sometimes in #sortContainer, sometimes outside of #sortContainer
		const offsetH1 = sortContainer.querySelector('h1') ? 7 : 80;
		
		// Account for the presence and height of sticky search
		const stickySearch = document.querySelector('#searchContainer.searchContainer--sticky');
		const stickySearchOffsetHeight = stickySearch ? stickySearch.offsetHeight : 0;

		const windowScrollY = window.scrollY;
		const scrollToY = sortContainer.offsetTop - offsetH1 - stickySearchOffsetHeight;

		if (windowScrollY > scrollToY) {
			const top = scrollToY;
			window.scrollTo({
				top
			});
		}

	} catch (error) {

		console.log(error);
		return false;

	}

	return true;

}

export default updatePage;
